import { app } from '../../../../app';
import { Controller } from './configuration.controller';

app.component('configuration', {
    bindings:{
        settings:'<',
    },
    controller: Controller,
    templateUrl: require('./configuration.html'),
});



// WEBPACK FOOTER //
// ./src/portal/states/company/saaspass-vpn/configuration/configuration.component.js